import { usePaypalRestMessages } from 'modules/profile/payment-gateways/integrations/paypal-rest/hooks/use-paypal-rest-messages'

export function PaypalRestMessages() {
  const { data } = usePaypalRestMessages()

  return data ? (
    <ul className={'flex list-inside list-disc flex-col gap-3'}>
      {data.messages.map((message, index) => (
        <li className={'whitespace-normal'} key={index}>
          {message}
        </li>
      ))}
    </ul>
  ) : null
}
